module.exports = __webpack_public_path__ + "img/upperBody.75a390ac.svg";